/**
 * Marker attribute used by the popup's outside-click handler to know a click
 * landed inside a submenu (submenus are rendered via a portal into document.body,
 * so they are not descendants of the popup's own ref).
 */
export const POPUP_SUBMENU_MARKER_ATTR = 'data-popup-submenu';

/**
 * Marks a control outside the popup that opens and closes it (the on-canvas action bar's More button).
 * The outside-click handler leaves pointer-downs on it alone so the control's own click can toggle the menu.
 */
export const POPUP_TOGGLE_MARKER_ATTR = 'data-popup-menu-toggle';

export const SUBMENU_HOVER_DELAY_MS = 300;

/** Viewport rect of the control a menu drops from. The menu opens next to it and never covers it. */
export interface PopupAnchorRect {
  top: number;
  bottom: number;
  left: number;
}
